import { css } from '@emotion/react';
import { type FC } from 'react';
import { useTranslation } from '../../../_shared/utils/hooks';
import { NumberOfRangesDropdownComponent } from './numberOfRangesDropdown.component';

type NumberOfRangesProps = Readonly<{
  className?: string;
  maxNumberOfRanges: number;
  numberOfRanges: number;
  onNumberOfRangesChange: (range: number) => void;
}>;

const dropdownHeadingStyle = css({
  margin: '0 0 10px',
  textTransform: 'uppercase',
  fontSize: '16px',
  lineHeight: 1.2,
});

export const NumberOfRangesComponent: FC<NumberOfRangesProps> = ({
  maxNumberOfRanges,
  numberOfRanges,
  onNumberOfRangesChange,
  className,
  ...restProps
}) => {
  const [t] = useTranslation();

  return (
    <div
      className={className}
      {...restProps}
    >
      <p css={dropdownHeadingStyle}>{t('Number Of Ranges')}</p>
      <NumberOfRangesDropdownComponent
        maxNumberOfRanges={maxNumberOfRanges}
        numberOfRanges={numberOfRanges}
        onNumberOfRangesChange={onNumberOfRangesChange}
      />
    </div>
  );
};
